import { t } from 'i18next'

import { ServerUnavailableError } from '@/shared/lib/errors/ServerUnavailableError'

import { wwtErrorLog } from '../../logger/wwtErrorLog'
import { ErrorHandlerResult } from '../../types/ErrorHandlerResult'
import { getRandomMessage } from '../getRandomMessage'

export const serverUnavailableErrorHandler = (
	error: ServerUnavailableError
): ErrorHandlerResult => {
	wwtErrorLog(`Server unavailable`, error)

	const messages = t('server.unavailable', {
		ns: 'errors',
		returnObjects: true
	})

	const { title, description } = getRandomMessage(messages)

	return {
		reset: true,
		toastInfo: {
			id: `server-unavailable-${error.message}`,
			title,
			description,
			variant: 'serverUnavailable'
		}
	}
}
